"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _LoggingEnabled_1 = require("./_LoggingEnabled");
exports.GetBucketLoggingOutput = {
    type: "structure",
    required: [],
    members: {
        LoggingEnabled: {
            shape: _LoggingEnabled_1._LoggingEnabled
        }
    }
};
//# sourceMappingURL=GetBucketLoggingOutput.js.map